import { render } from "./AtendimentoDetalheForm.vue?vue&type=template&id=30d450e3"
import script from "./AtendimentoDetalheForm.vue?vue&type=script&lang=js"
export * from "./AtendimentoDetalheForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__